<template>
    <div>
        <div class="container">
            <slot/>
        </div>
    </div>
</template>

<script>
export default {
    name: 'container'
}
</script>

<style lang="scss" scoped>
@import '../assets/css/vars';
.container {

    margin: 0 auto;

    @media (min-width: $min-md) {
        width: 111rem;
    }
    @media (min-width: $min-sm) and (max-width: $max-sm) {
        width: 50rem;
    }
    @media (max-width: $max-xs) {
        width: 100vw;
        padding: 0 25px;
    }
    @media (max-width: $max-xs) and (orientation: landscape) {
        padding: 0 10rem;
    }
}
</style>
